

import React from "react";

export const IconTab = ({ className,icon,state }) => {
switch (icon) {

                        case "CableCarWhite":
                          return (
                            <svg
                            className={`${className}`}
                            fill="none"
                            height="24"
                            viewBox="0 0 24 24"
                            width="24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 3H10.01M14 2H14.01M2 9L22 4M12 12V6.5M9 12V17M15 12V17M4 17H20M7 12H17C18.6569 12 20 13.3431 20 15V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V15C4 13.3431 5.34315 12 7 12Z"
                              stroke={state=="active"?"white":"black"}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                            />
                          </svg>
                            );
                          break;

                          
                        case "EventBlack":
                            return (
                                <svg
                                className={`${className}`}
                                fill="none"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3 10H21V6C21 5.46957 20.7893 4.96086 20.4142 4.58579C20.0391 4.21071 19.5304 4 19 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H12M8 2V6M16 2V6M21.29 14.7C20.9493 14.3609 20.5156 14.1305 20.0439 14.038C19.5722 13.9454 19.0836 13.9948 18.64 14.18C18.34 14.3 18.07 14.48 17.84 14.71L17.5 15.05L17.15 14.71C16.8104 14.3693 16.3772 14.137 15.9055 14.0426C15.4337 13.9483 14.9446 13.9961 14.5 14.18C14.2 14.3 13.94 14.48 13.71 14.71C12.76 15.65 12.71 17.24 13.91 18.45L17.5 22L21.1 18.45C22.3 17.24 22.24 15.65 21.29 14.71V14.7Z"
                                  stroke={state=="active"?"white":"black"}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                />
                              </svg>
                              );
                            break;


                            case "DinningGrey":
                                return (
                                    <svg
                                    className={`${className}`}
                                    fill="none"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    width="16"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0_1479_509)" opacity="0.5">
                                      <path
                                        d="M10.6665 1.3335L9.13312 2.86683C8.76666 3.24069 8.5614 3.74332 8.5614 4.26683C8.5614 4.79034 8.76666 5.29297 9.13312 5.66683L10.3331 6.86683C10.707 7.23328 11.2096 7.43854 11.7331 7.43854C12.2566 7.43854 12.7593 7.23328 13.1331 6.86683L14.6665 5.3335M9.99978 10.0002L2.19978 2.20016C1.9337 2.46087 1.72232 2.77204 1.57801 3.11546C1.43371 3.45889 1.35938 3.82765 1.35938 4.20016C1.35938 4.57267 1.43371 4.94144 1.57801 5.28486C1.72232 5.62828 1.9337 5.93946 2.19978 6.20016L7.06645 11.0668C7.53312 11.5335 8.39978 11.5335 8.93312 11.0668L9.99978 10.0002ZM9.99978 10.0002L14.6665 14.6668M1.39978 14.5335L5.66645 10.3335M12.6665 3.3335L7.99978 8.00016"
                                        stroke="white"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="1.33333"
                                      />
                                    </g>
                              
                                    <defs>
                                      <clipPath id="clip0_1479_509">
                                        <rect fill="white" height="16" width="16" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  );
                                break;
                                case "CalenderHeartGrey":
                                    return (
                                        <svg
      className={`${className}`}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M2 6.66683H14V4.00016C14 3.64654 13.8595 3.3074 13.6095 3.05735C13.3594 2.80731 13.0203 2.66683 12.6667 2.66683H3.33333C2.97971 2.66683 2.64057 2.80731 2.39052 3.05735C2.14048 3.3074 2 3.64654 2 4.00016V13.3335C2 13.6871 2.14048 14.0263 2.39052 14.2763C2.64057 14.5264 2.97971 14.6668 3.33333 14.6668H8M5.33333 1.3335V4.00016M10.6667 1.3335V4.00016M14.1933 9.80016C13.9662 9.57412 13.6771 9.42053 13.3626 9.35882C13.0481 9.29711 12.7224 9.33006 12.4267 9.4535C12.2267 9.5335 12.0467 9.6535 11.8933 9.80683L11.6667 10.0335L11.4333 9.80683C11.2069 9.57966 10.9182 9.42482 10.6036 9.36192C10.2891 9.29902 9.96304 9.33089 9.66667 9.4535C9.46667 9.5335 9.29333 9.6535 9.14 9.80683C8.50667 10.4335 8.47333 11.4935 9.27333 12.3002L11.6667 14.6668L14.0667 12.3002C14.8667 11.4935 14.8267 10.4335 14.1933 9.80683V9.80016Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.33333"
        />
      </g>
    </svg>
                                      );
                                    break;

    default:
        return (<></>)
        break;
}
};
